module.exports = __webpack_public_path__ + "img/1193720457.8dd936ed.jpg";